




























import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import {
  AuthorityTable,
  AuthorityTableItem,
  defaultAuthorityTableItem
} from '@/components/organisms/AuthorityTable'
import {
  AlertMessage,
  AuthorityPublisher,
  bibliographyApi,
  ErrorMessage
} from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { AuthorityItem } from '@/types'

@Component({
  components: {
    AuthorityTable,
    ModalFooter
  }
})
export default class ModalAuthorityPublisherHelp extends ComponentVue {
  @Prop({
    type: String,
    required: true
  })
  searchKey!: string

  dialog: boolean = false

  items: AuthorityTableItem[] = []

  selectedItem: AuthorityTableItem = defaultAuthorityTableItem()

  open(): void {
    this.fetchAll()
  }

  close(): void {
    this.dialog = false
  }

  async fetchAll() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const responses: AuthorityPublisher[] = await bibliographyApi.getBibliographyAuthorityPublisher(
        this.searchKey
      )
      this.items = responses.map((response, index) => {
        return {
          isSelected: index === 0,
          ...response
        }
      })
      this.dialog = true
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onSelected(index: number) {
    if (this.items[index].isSelected) return

    this.items.some(item => {
      if (item.authorityNo === this.items[index].authorityNo) {
        item.isSelected = true
        return false
      }
      item.isSelected = false
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-authority-publisher-help')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  @Emit('ok')
  onClickOk() {
    this.close()
    const selectedItem: AuthorityTableItem | undefined = this.items.find(
      item => item.isSelected
    )

    if (selectedItem === undefined) return null

    const item: AuthorityItem = {
      authorityNo: selectedItem.authorityNo,
      tag: selectedItem.tag,
      display: selectedItem.display,
      displayKana: selectedItem.displayKana
    }
    return item
  }
}
